'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = exports.isInvocation = exports.matchEvent = exports.buildMap = exports.invocations = exports.INVOCATION_REQUESTRESPONSE = exports.INVOCATION_FIREANDFORGET = exports.channels = exports.CHANNEL_OUTGOING = exports.CHANNEL_INCOMING = exports.CHANNEL_INTERNAL = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _EventMap = require('./EventMap');

var _EventMap2 = _interopRequireDefault(_EventMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {string}
 */
var CHANNEL_INTERNAL = exports.CHANNEL_INTERNAL = 'event.channel_internal';

/**
 * @type {string}
 */
/**
 * This module export constants and utilities functions that apply to Event objects
 *
 * @module Core/Event
 */

var CHANNEL_INCOMING = exports.CHANNEL_INCOMING = 'event.channel_incoming';

/**
 * @type {string}
 */
var CHANNEL_OUTGOING = exports.CHANNEL_OUTGOING = 'event.channel_outgoing';

/**
 * The list of event channels
 *
 * @enum
 * @type {{CHANNEL_INCOMING: string, CHANNEL_INTERNAL: string, CHANNEL_OUTGOING: string}}
 */
var channels = exports.channels = {
  CHANNEL_INCOMING: CHANNEL_INCOMING,
  CHANNEL_INTERNAL: CHANNEL_INTERNAL,
  CHANNEL_OUTGOING: CHANNEL_OUTGOING
};

/**
 * @type {string}
 */
var INVOCATION_FIREANDFORGET = exports.INVOCATION_FIREANDFORGET = 'event.invocation_fireandforget';

/**
 * @type {string}
 */
var INVOCATION_REQUESTRESPONSE = exports.INVOCATION_REQUESTRESPONSE = 'event.invocation_requestresponse';

/**
 * @enum
 * @type {{INVOCATION_FIREANDFORGET: string, INVOCATION_REQUESTRESPONSE: string}}
 */
var invocations = exports.invocations = {
  INVOCATION_FIREANDFORGET: INVOCATION_FIREANDFORGET,
  INVOCATION_REQUESTRESPONSE: INVOCATION_REQUESTRESPONSE
};

/**
 * Builds an event map from an object literal description where keys are event keys and values are event names
 *
 * @method
 *
 * @param {Object} events
 * @param {Object} eventProps
 * @return {EventMap}
 */
var buildMap = exports.buildMap = function buildMap(events, eventProps) {
  var names = (0, _keys2.default)(events).map(function (key) {
    return events[key];
  });

  var map = {};
  (0, _keys2.default)(events).forEach(function (key) {
    var value = events[key];
    map[key] = value;
    map[value] = key;
  });

  return new _EventMap2.default({ map: map, names: names, props: eventProps });
};

/**
 * @method
 *
 * @param {String} eventName
 * @param {Object} propsPattern
 * @param {EventMap} eventMap
 * @return {boolean}
 */
var matchEvent = exports.matchEvent = function matchEvent(eventName, propsPattern, eventMap) {
  if (!eventMap.isEventName(eventName)) {
    return false;
  }

  if (!propsPattern) {
    return true;
  }

  var actualProps = eventMap.getEventProps(eventName);
  return matchProps(actualProps, propsPattern);
};

/**
 * @param {{}} props
 * @return {boolean}
 */
var isInvocation = exports.isInvocation = function isInvocation(props) {
  if (!props || (typeof props === 'undefined' ? 'undefined' : (0, _typeof3.default)(props)) !== 'object') {
    return false;
  }

  var event = props.event;

  if (typeof event !== 'string') {
    return false;
  }

  var invocationType = props.invocationType;

  return -1 !== (0, _keys2.default)(invocations).reduce(function (acc, key) {
    return acc.concat(invocations[key]);
  }, []).indexOf(invocationType);
};

/**
 *
 * @param {*} actualProps
 * @param {String} channelType
 * @param {String} invocationType
 * @return {boolean}
 */
var matchProps = function matchProps(actualProps, _ref) {
  var channelType = _ref.channelType,
      invocationType = _ref.invocationType;

  if (!actualProps) {
    return !channelType && !invocationType;
  }

  if (!channelType && !invocationType) {
    return false;
  }
  if (channelType && actualProps.channelType !== channelType) {
    return false;
  }
  if (invocationType && actualProps.invocationType !== invocationType) {
    return false;
  }

  return true;
};

/**
 * @class Event
 */

var Event = function () {
  /**
   * @param {String} name event name
   * @param {Array} args event arguments
   */
  function Event(_ref2) {
    var name = _ref2.name,
        args = _ref2.args;
    (0, _classCallCheck3.default)(this, Event);

    this.props = { name: name, enabled: true, args: args };
  }

  /**
   * @readonly
   * @type {Array}
   */


  (0, _createClass3.default)(Event, [{
    key: 'args',
    get: function get() {
      return JSON.parse((0, _stringify2.default)(this.props.args));
    }

    /**
     * @ignore
     * @type {boolean}
     */

  }, {
    key: 'enabled',
    set: function set(flag) {
      this.props.enabled = flag;
    }

    /**
     * @public
     * @type {boolean}
     */
    ,
    get: function get() {
      return this.props.enabled;
    }
  }]);
  return Event;
}();

exports.Event = Event;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/Event.js
// module id = 17
// module chunks = 0